import { format } from 'owa-strings';
import { formatUserTime, formatWeekDayDate, formatWeekDayShortUserDate } from 'owa-datetime';
import { OwaDate } from 'owa-datetime/lib/owaDate/owaDate';
import isEqual from 'owa-datetime/lib/owaDate/isEqual';
import subDays from 'owa-datetime/lib/owaDate/subDays';
import { getOwaDatetimeStrings } from 'owa-strings/owa-datetime-strings';

export function formatOneDayAllDayTimeSpan(
    startDate: OwaDate,
    endDate: OwaDate,
    isShortString: boolean
): string {
    return format(
        getOwaDatetimeStrings().oneDayAllDayFormatString,
        formatDateString(startDate, isShortString)
    );
}

export function formatMultiDayAllDayTimeSpan(
    startDate: OwaDate,
    endDate: OwaDate,
    isShortString: boolean
): string {
    return format(
        getOwaDatetimeStrings().multiDayAllDayFormatString,
        formatDateString(startDate, isShortString),
        formatDateString(subDays(endDate, 1), isShortString)
    );
}

export function formatSingleDayTimeSpan(
    startDate: OwaDate,
    endDate: OwaDate,
    isShortString: boolean
): string {
    if (isEqual(startDate, endDate)) {
        return format(
            getOwaDatetimeStrings().sameDayNoDurationFormatString,
            formatDateString(startDate, isShortString),
            formatUserTime(startDate)
        );
    }

    return format(
        getOwaDatetimeStrings().sameDayFormatString,
        formatDateString(startDate, isShortString),
        formatUserTime(startDate),
        formatUserTime(endDate)
    );
}

export function formatSingleDayTimeSpanWithoutDate(startDate: OwaDate, endDate: OwaDate): string {
    return format(
        getOwaDatetimeStrings().timeSpanFormatString,
        formatUserTime(startDate),
        formatUserTime(endDate)
    );
}

export function formatMultiDayTimeSpan(
    startDate: OwaDate,
    endDate: OwaDate,
    isShortString: boolean
): string {
    return format(
        getOwaDatetimeStrings().differentDayFormatString,
        formatDateString(startDate, isShortString),
        formatUserTime(startDate),
        formatDateString(endDate, isShortString),
        formatUserTime(endDate)
    );
}

export function formatDateString(date: OwaDate, isShortString: boolean) {
    return (isShortString ? formatWeekDayShortUserDate : formatWeekDayDate)(date);
}
